import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import PolicyTimelineVisualization from './components/PolicyTimelineVisualization';
import AlertSimulationEngine from './components/AlertSimulationEngine';
import DeviceCategoryFiltering from './components/DeviceCategoryFiltering';
import PolicyImpactCalculator from './components/ComplianceImpactCalculator';
import DemoResourcesSection from './components/DemoResourcesSection';
import APIIntegrationShowcase from './components/APIIntegrationShowcase';

const PlatformDemo = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1">
        <HeroSection />
        <PolicyTimelineVisualization />
        <AlertSimulationEngine />
        <DeviceCategoryFiltering />
        <PolicyImpactCalculator />
        <DemoResourcesSection />
        <APIIntegrationShowcase />
      </main>

      <Footer />
    </div>
  );
};

export default PlatformDemo;